import { Injectable } from '@angular/core';
import { StateService } from '@uirouter/angular';
import { GfTranslateService } from '../../../core/services/core.translate.service';
import * as _ from 'lodash';
import { marker } from '../../../core/services/ngx-translate-extract-marker';

@Injectable()
export class ScmLinkService {
  constructor(
    private stateService: StateService,
    private translateService: GfTranslateService
  ) {}

  private newItem(name: string, state: string, params?: any) {
    return {
      label: name,
      state: state,
      params: params || {},
    };
  }

  projectCrumb(project: any) {
    const currentParams = this.stateService.params;
    return this.newItem(
      _.get(project, 'name', 'Project'),
      'home.project.summary',
      { ...currentParams, unixName: _.get(project, 'unixName', '')}
    );
  }

  scmBrowseRootCrumb(stateParams: any) {
    return this.newItem(
      this.translateService.translate('(root)'),
      'home.project.summary.scm.browse',
      { ...stateParams, path: '' }
    );
  }

  translatedCrumb(label: string, state: string, stateParams: any) {
    return this.newItem(
      this.translateService.translate(label),
      state,
      stateParams
    );
  }

  crumbsFor = {
    info: (project: any) => {
      return [
        this.projectCrumb(project),
        this.translatedCrumb(marker('Information'), 'home.project.summary.scm', {
          unixName: project.unixName,
        }),
      ];
    },
    commits: (stateParams: any, project: any) => {
      return [
        this.projectCrumb(project),
        this.translatedCrumb(marker('Commits'), 'home.project.summary.scm.commits', stateParams),
      ];
    },
    commit: (stateParams: any, project: any) => {
      const crumbs = this.crumbsFor.commits(stateParams, project);
      crumbs.push(
        this.newItem(
          _.get(stateParams, 'commithash', '').slice(0, 7),
          'home.project.summary.scm.commit',
          stateParams
        )
      );
      return crumbs;
    },
    merge: (stateParams: any, project: any, scm: any) => {
      const label = _.get(scm, 'scmType', '') === 'git' ? marker('Merge') : marker('Review');

      return [
        this.projectCrumb(project),
        this.translatedCrumb(label, 'home.project.summary.scm.merge', stateParams),
      ];
    },
    browse: (stateParams: any, project: any) => {
      const root = [this.projectCrumb(project), this.scmBrowseRootCrumb(stateParams)];

      let fullPath = '';
      const pathParam = decodeURIComponent(decodeURIComponent(_.get(stateParams, 'path', '')));
      const pathElements = _.filter(pathParam.split('/'), (e) => e !== '');

      const paths = pathElements
        .map((p) => {
          fullPath = fullPath ? `${fullPath}/${p}` : p;

          return this.newItem(
            p,
            'home.project.summary.scm.browse',
            { ...stateParams, path: fullPath }
          );
        })
        .filter((item) => item.label !== '');

      const result = root.concat(paths);
      if (result.length > 1) {
        result[result.length - 1].state = '';
      }
      return result;
    },
  };
}
